module.exports = __webpack_public_path__ + "static/img/tool_service_3.7938342c.png";